import { Form, Modal, Tooltip } from 'react-bootstrap'
import styled from 'styled-components'
import { colorDanger, colorWarning } from 'common/theme'

export const StyledArbitrationFormBody = styled(Form)``

export const StyledArbitrationModal = styled(Modal)`
  .modal-content {
    border: 1px solid ${({ theme }) => theme.colors.inputBorder || '#ced4da'};
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
    max-height: calc(100vh - 40px);
    display: flex;
    flex-direction: column;
  }

  .modal-dialog {
    max-width: 980px;
    max-height: calc(100vh - 40px);
    margin: 20px auto;
  }

  .modal-header {
    background-color: ${({ theme }) => theme.headerSticky?.backgroundColor};
    border-bottom: 1px solid ${({ theme }) => theme.headerSticky?.backgroundColor};

    .modal-title {
      font-size: 20px;
      font-weight: 600;
      color: ${({ theme }) => theme.headerSticky?.text};
      margin-left: 5px;
    }

    .close span {
      font-size: 20px;
      color: ${({ theme }) => theme.headerSticky?.text};
    }
  }

  .modal-body {
    background-color: ${({ theme }) => theme.colors.backgroundText || '#fff'};
    padding: 14px 20px;
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
    overflow-y: auto;
    flex: 1 1 auto;
    min-height: 0;
  }

  .modal-footer {
    background-color: ${({ theme }) => theme.colors.backgroundText || '#fff'};
    border-top: 1px solid ${({ theme }) => theme.colors.inputBorder || '#ced4da'};

    .btn-group {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      width: auto;
      margin-left: auto;
      flex: 0 0 auto;
    }

    .btn-primary {
      background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      color: ${({ theme }) => theme.colors.stickyTextColor};

      &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.backgroundText};
        border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
        color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      }
    }

    .btn-outline-secondary {
      background-color: ${({ theme }) => theme.colors.cancelButtonBackgroundColor};
      color: ${({ theme }) => theme.colors.cancelButtonColor};
      border-color: ${({ theme }) => theme.colors.cancelButtonColor};

      &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.cancelButtonHoverBackgroundColor};
        color: ${({ theme }) => theme.colors.cancelButtonBackgroundColor};
        border-color: ${({ theme }) => theme.colors.cancelButtonHoverBackgroundColor};
      }
    }
  }
`

export const StyledArbitrationFormLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
`

export const StyledFormSubmitOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.6);
  cursor: not-allowed;
`

export const StyledFormSection = styled.div`
  margin-bottom: 10px;

  h6 {
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
    margin-bottom: 8px;
  }

  .form-label {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
    line-height: 1.4;

    .required-indicator {
      color: ${colorDanger};
    }
  }

  .invalid-feedback {
    color: ${colorDanger};
    font-size: 0.875em;
  }

  .form-control[readonly],
  .form-control:disabled,
  select.form-control:disabled,
  textarea.form-control:disabled {
    background-color: #eef2f6;
    border-color: #c9d3df;
    opacity: 1;
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
    cursor: not-allowed;
  }

  .form-control,
  select.form-control,
  textarea.form-control {
    min-height: 38px;
    border-color: ${({ theme }) => theme.colors.inputBorder || '#ced4da'};
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
    padding-left: 12px;
    padding-right: 12px;
    font-size: 14px;

    &:focus {
      border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
      box-shadow: 0 0 0 0.2rem rgba(23, 59, 104, 0.12);
    }
  }

  select.form-control {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23555' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    padding-right: 30px;
  }

  .form-group-inline {
    display: grid;
    grid-template-columns: 190px minmax(0, 320px);
    gap: 8px 12px;
    align-items: start;
    padding: 0px 12px;
  }

  .form-group-inline > .form-label {
    margin-bottom: 0;
    padding-top: 8px;
    white-space: nowrap;
  }

  .form-group-inline > :not(.form-label) {
    grid-column: 2;
  }

  .field-character-count {
    grid-column: 2;
    display: block;
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.4;
    text-align: right;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
  }

  .form-group-inline textarea.form-control {
    resize: none;
  }

  .form-group-inline.full-width textarea.form-control.reason-textarea {
    width: 100%;
    min-height: 80px;
    height: 80px;
    overflow-y: auto;
  }

  .form-group-inline.full-width .field-character-count.reason-character-count {
    width: 100%;
  }

  .form-group-inline.full-width {
    grid-template-columns: 190px minmax(0, 1fr);
  }

  .form-group-inline.full-width > :not(.form-label) {
    grid-column: 2;
    width: 100%;
    max-width: none;
  }

  .attachment-field-group {
    display: grid;
    grid-template-columns: 190px minmax(0, 1fr);
    gap: 8px 12px;
    align-items: start;
    padding: 0px 12px;
  }

  .attachment-field-group > .form-label {
    margin-bottom: 0;
    padding-top: 8px;
    white-space: nowrap;
  }

  .attachment-field-content {
    min-width: 0;
    padding: 8px 0px;
  }

  .attachment-helper-panel {
    margin-bottom: 12px;
  }

  .attachment-helper-text {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .attachment-helper-text.is-priority {
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
    font-style: italic;
    font-weight: 500;
  }

  .attachment-helper-text.is-limit,
  .attachment-helper-text.is-format,
  .attachment-helper-text.is-disabled {
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
  }

  .pending-upload-block {
    margin-top: 12px;
  }

  .uploaded-document-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px 12px;
  }

  .uploaded-document-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder || '#ced4da'};
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.backgroundText || '#f7f8fa'};
    font-size: 13px;
  }

  .uploaded-document-name {
    min-width: 0;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
  }

  .remove-document-button {
    padding: 0;
    min-width: auto;
    font-size: 13px;
    line-height: 1.4;
    white-space: nowrap;
  }
`

export const StyledReadOnlyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;

  .read-only-item {
    display: grid;
    grid-template-columns: 190px minmax(0, 320px);
    align-items: start;
    gap: 8px;
    padding: 0px 12px;
  }

  .read-only-item.full-width {
    grid-column: 1 / -1;
    grid-template-columns: 190px minmax(0, 1fr);
  }

  .read-only-item.full-width .read-only-value {
    width: 100%;
    max-width: none;
  }

  .read-only-item.full-width .read-only-value.reason-value {
    width: 100%;
    min-height: 80px;
    height: 80px;
    overflow-y: auto;
  }

  .read-only-label {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
    line-height: 1.4;
    white-space: nowrap;
  }

  .read-only-value {
    display: block;
    width: 100%;
    min-height: 38px;
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder || '#ced4da'};
    border-radius: 4px;
    background-color: #e4ebf2;
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
    font-size: 14px;
    word-break: break-word;
  }
`

export const StyledExistingDocuments = styled.div`
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr);
  gap: 8px 12px;
  align-items: start;
  padding: 0 12px;

  .form-label {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
    line-height: 1.4;
    margin-bottom: 0;
    padding-top: 8px;
    white-space: nowrap;
  }

  .documents-panel {
    min-width: 0;
    min-height: 38px;
    padding: 12px 0;
  }

  .documents-caption {
    margin-bottom: 8px;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
  }

  .documents-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px 16px;
  }

  .document-pill {
    font-size: 13px;
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0;
    line-height: 1.5;
  }
`

export const StyledMileageWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background-color: #fff8e1;
  border-left: 4px solid ${colorWarning};
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 4px;
  font-size: 13px;
  color: #7a6000;
`

export const StyledConfirmationPanel = styled.div`
  text-align: center;
  padding: 30px 20px;

  .confirmation-icon {
    font-size: 48px;
    color: #26ad77;
    margin-bottom: 16px;
  }

  h5 {
    font-weight: 600;
    margin-bottom: 8px;
  }

  .case-id {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
    margin-bottom: 4px;

    strong {
      color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
    }
  }
`

export const StyledDocumentError = styled.div`
  color: ${colorDanger};
  font-size: 13px;
  margin-top: 4px;
`

export const StyledAttachmentDropzone = styled.div<{ isDragActive: boolean; isDisabled: boolean }>`
  min-height: 120px;
  border: 2px dashed
    ${({ theme, isDragActive }) =>
      isDragActive ? theme.colors.InfinitiOnlyColor : theme.colors.inputBorder || '#ced4da'};
  border-radius: 4px;
  background-color: ${({ theme, isDragActive }) => (isDragActive ? theme.colors.backgroundText || '#f7f8fa' : '#fff')};
  color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
  padding: 20px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.65 : 1)};
  transition: border-color 0.2s ease, background-color 0.2s ease;

  .dropzone-content {
    display: flex;
    flex-direction: column;
    max-width: 460px;
  }

  .dropzone-title {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
  }
`
export const StyledTooltip = styled(Tooltip)`
  opacity: 1 !important;

  .tooltip-inner {
    color: black;
    font-size: 14px;
    max-width: 500px;
    background-color: white;
    box-shadow: rgb(0 0 0 / 15%) 0px 2px 4px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    text-align: left;
  }

  .arrow::before {
    border-style: none;
  }
`
